import styled from 'styled-components';

import {
  Colors,
  maxWidth,
  padding,
  compactPadding,
  MediaQueryBreakpoints,
} from '@rockalingua/ui';

export const Background = styled.footer`
  background-color: ${Colors.MAIN_VARIANTS[60]};
  width: 100vw;
  margin-left: calc(-50vw + 50%);
  margin-top: -24px;
  margin-bottom: -${24 + padding}px;

  @media (${MediaQueryBreakpoints.isUltraWide}) {
    margin-bottom: -${24 + compactPadding}px;
  }

  @media only screen and (max-width: ${MediaQueryBreakpoints.sm}px) {
    margin-bottom: -${24 + compactPadding}px;
  }
`;

export const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  max-width: ${maxWidth}px;
  margin: 0 auto;
  padding: 24px 48px;
`;
